import { Injectable } from "@angular/core";
import { TaxiParada } from "@tivic-team/manager-ts/dist/mob/entities/taxi/taxi-parada.entity";
import { TaxiParadaController } from "app/controllers/mob/taxi-parada.controller";
import { TaxiParadaServiceInteface } from "app/interface/mob/taxi-parada-service.inteface";
import { TaxiParadaListDTO } from "app/model/dtos/mob/taxi-parada.dto";
import { LoaderService } from "../loader.service";
import { TaxiParadaSearch } from "./taxi-parada.search";

@Injectable({
  providedIn: "root",
})

export class TaxiParadaService implements TaxiParadaServiceInteface<TaxiParada>{

  constructor(
    private _taxiParadaController: TaxiParadaController,
    private _loaderService: LoaderService
  ) { }

  find(search?: TaxiParadaSearch): Promise<TaxiParada[]> {
    this._loaderService.show();
    return this._taxiParadaController.find(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  get(id: number, id_2: number): Promise<TaxiParada> {
    this._loaderService.show();
    return this._taxiParadaController.get(id, id_2).finally(() => this._loaderService.hide());
  }

  save(entity: TaxiParada): Promise<TaxiParada> {
    if (!entity.cdParada)
      return this.create(entity);
    return this.update(entity);
  }

  create(entity: TaxiParada): Promise<TaxiParada> {
    this._loaderService.show();
    return this._taxiParadaController.create(entity).finally(() => this._loaderService.hide());
  }

  update(entity: TaxiParada): Promise<TaxiParada> {
    this._loaderService.show();
    return this._taxiParadaController.update(entity).finally(() => this._loaderService.hide());
  }

  pagedFind(search?: TaxiParadaSearch): Promise <TaxiParadaListDTO>{
    this._loaderService.show();
    return this._taxiParadaController.pagedFind(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }

  findParadas(search?: TaxiParadaSearch): Promise <TaxiParadaListDTO>{
    this._loaderService.show();
    return this._taxiParadaController.findParadas(search && search.getFilters() || null).finally(() => this._loaderService.hide());
  }
}
